import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class FullStackEngineer extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Senior Full Stack Engineer</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">
                        
                        <SNIntro />

                        <p className="p2">We are hiring a versatile <b>Senior Full Stack Engineer</b> to contribute to the front-end and back-end of the platform. This role requires Javascript fluency and experience with modern web development. An ideal candidate is comfortable building web applications, APIs, and working with relational databases.
                        </p>
                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">Develop complex single-page web applications using React.js and Redux.
                            </li>
                            <li className="p3">{`Create APIs that power Social Native's applications and dashboards.`}</li>
                            <li className="p3">Collaborate with product and design teams to create the best experience
                                for our customers and creators.
                            </li>
                            <li className="p3">Be involved in every phase of the software lifecycle (requirements,
                                development, deployment, monitoring).
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Traits of an Ideal Candidate</b></span></p>
                        <ul className="l1">
                            <li className="p3">Willingness to learn: you use the best tool for the job, even if it
                                requires learning something new.
                            </li>
                            <li className="p3">Process-oriented: you like to automate things and improve the development
                                workflow.
                            </li>
                            <li className="p3">Diligent: you write tests and do everything in your power to ensure code
                                is shipped frequently and without issue.
                            </li>
                            <li className="p3">Product-focused: you work well with product managers and designers to
                                create compelling user experiences.
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">Track record of delivering quality software.</li>
                            <li className="p3">Autonomous and self-managed.</li>
                            <li className="p3">Excellent communications skills.</li>
                            <li className="p3">Computer Science or Engineering degree from a 4 year program.</li>
                            <li className="p3">Startup experience.</li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Relevant Technology</b></span></p>
                        <ul className="l1">
                            <li className="p3">Languages</li>
                            <ul className="l2">
                                <li className="p3">Javascript (ES6)</li>
                                <li className="p3">PHP</li>
                            </ul>
                            <li className="p3">Databases</li>
                            <ul className="l2">
                                <li className="p3">MySQL/Postgres</li>
                                <li className="p3">Redis</li>
                            </ul>
                            <li className="p3">Frameworks</li>
                            <ul className="l2">
                                <li className="p3">Node.js</li>
                                <li className="p3">React.js/Redux</li>
                                <li className="p3">Laravel</li>
                                <li className="p3">Webpack + Babel</li>
                            </ul>
                            <li className="p3">Infrastructure (Amazon Web Services)</li>
                            <ul className="l2">
                                <li className="p3">Elastic Beanstalk</li>
                                <li className="p3">Lambda</li>
                                <li className="p3">RDS</li>
                            </ul>
                        </ul>
                        <p className="p1"><span className="s1"><b>Engineering Culture at SN</b></span></p>
                        <ul className="l1">
                            <li className="p3">Follow best practices.</li>
                            <li className="p3">Use the best tool for the job.</li>
                            <li className="p3">Write quality code.</li>
                            <li className="p3">Own and contribute to the product.</li>
                            <li className="p3">Be humble and repsect the ideas of others.</li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/full_stack_engineer.js